import { CustomColumn } from '../../../../../types/components/tables/tableTypes';
import { specifyStatus } from '../../../../../utilities/generalMappings';
import GenericStatusCell from '../../../../tables/GenericStatusCell';

import { RiskCompStatus, sortByStatusOrder } from './buildComparisonTable';

export interface IRiskComparisonTablePositionChangesData {
  number: number;
  genericMarket: string;
  instrument: string;
  info: string;
  positionReference: number | string;
  trade: string;
  comparisonPosition: string;
  market: number | string;
  risk: number;
  portfolio: number | string;
  status: RiskCompStatus;
  positionName: string;
}
export const csvPosition = [
  'number',
  'genericMarket',
  'instrument',
  'info',
  'positionReference',
  'comparisonPosition',
  'market',
  'risk',
  'portfolio',
  'status',
];

export function usePositionChangesColumns(): CustomColumn<IRiskComparisonTablePositionChangesData>[] {
  return [
    {
      field: 'number',
      title: '#',
      width: '1%',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'center',
        padding: 0,
      },
    },
    {
      field: 'genericMarket',
      title: 'Asset Name',
      cellStyle: { textWrap: 'nowrap', padding: 0 },
    },
    {
      field: 'instrument',
      title: 'Instrument Type',
      headerStyle: { textAlign: 'center' },
      cellStyle: { textAlign: 'center', padding: 0 },
    },
    {
      field: 'info',
      title: 'Maturity',
      headerStyle: { textAlign: 'center' },
      cellStyle: { textAlign: 'center', padding: 0 },
    },
    {
      field: 'positionReference',
      title: 'Old Position',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'center',
        padding: 0,
      },
    },

    {
      field: 'trade',
      title: 'Trade %',
      headerStyle: { textAlign: 'center' },
      cellStyle: { textAlign: 'center', padding: 0 },
      render: (rowData) => {
        const tradeValue = parseFloat(rowData.trade);
        const colorClass =
          tradeValue > 0
            ? 'text-green-600'
            : tradeValue < 0
              ? 'text-red-600'
              : 'text-black';

        return <span className={colorClass}>{rowData.trade}</span>;
      },
    },

    {
      field: 'comparisonPosition',
      title: 'New Position',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'center',
        padding: 0,
      },
    },

    {
      field: 'market',
      title: 'Market Price',
      headerStyle: { textAlign: 'center' },
      cellStyle: { textAlign: 'center', padding: 0 },
    },
    {
      field: 'status',
      title: 'Status',
      render: (rowData) => (
        <GenericStatusCell status={specifyStatus(rowData.status)} />
      ),
      cellStyle: { padding: '0.5rem' },
      headerStyle: { textAlign: 'center', padding: 0 },
      customSort: sortByStatusOrder,
    },
  ];
}
